/* unplugin-vue-components disabled */import { render } from "./ChangeUsername.vue?vue&type=template&id=13f4afee&scoped=true"
import script from "./ChangeUsername.vue?vue&type=script&lang=js"
export * from "./ChangeUsername.vue?vue&type=script&lang=js"

import "./ChangeUsername.vue?vue&type=style&index=0&id=13f4afee&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f4afee"]])

export default __exports__